import axios from "../../../config/axiosConfig";

export const buscarPagoMasivo = (params) => axios.get("/api/pago-masivo", { params });
export const previewPagoMasivo = (data) => axios.post("/api/pago-masivo/preview", data);
export const guardarPagoMasivo = (data) => axios.post("/api/pago-masivo/guardar", data);
